/** @type {import('tailwindcss').Config} */
import plugin from "tailwindcss/plugin";

export default {
	content: ["./src/**/*.{js,jsx,ts,tsx}"],
	important: "#body",
	theme: {
		fontFamily: {
			mic: ["MAD RUS", "system-ui"],
			inter: ["Inter", "system-ui"],
			avenir: ["Avenir Next", "Inter", "Avenir", "Helvetica", "Arial", "sans-serif"]
		},
		extend: {
			colors: {
				red: {
					300: "#FF4032",
					400: "#8C1717",
					500: "#871717",
					600: "#6A0909",
					700: "#3A1213",
					800: "#200D0D",
					900: "#2D1111",
					dark: "#3A0909",
					extraDark: "#1F0202"
				},
				gray: {
					400: "#D9D9D9",
					600: "#646273"
				},
				yellow: {
					300: "#FFE46B",
					350: "#FFDE67",
					400: "#FFC452",
					450: "#FFD664",
					500: "#FFDF54"
				},
				green: {
					400: "#0EC04A",
					dark: "#05521F"
				},
				brown: {
					400: "#5C2405"
				}
			}
		}
	},
	plugins: [
		plugin(function ({ addVariant }) {
			addVariant("svg", "& > svg");
			addVariant("svg-paths", "& path");
			addVariant("svg-first-path", "& > path:first-of-type");
			addVariant("svg-last-path", "& > path:last-of-type");
			addVariant("svg-lines", "& > line");
			addVariant("svg-first-line", "& > line:first-of-type");
			addVariant("svg-last-line", "& > line:last-of-type");
			addVariant("svg-g", "& > g");
			addVariant("svg-circles", "& > circle");
			addVariant("svg-rects", "& > rect");
		})
	],
	variants: {
		extend: {
			display: ["group-hover"]
		}
	}
};
